<template>
  <div class="cmp-wrapper">
    <basic-container>
      <el-form
        ref="addPersonnel"
        :rules="rules"
        :disabled="$route.query.type==='1'"
        :model="formData"
        label-width="120px"
        label-position="left"
        size="medium"
      >
        <p class="title">人员信息</p>
        <el-form-item label="人员姓名" prop="memberName">
          <el-input v-model="formData.memberName" placeholder="请输入人员姓名"></el-input>
        </el-form-item>
        <p class="title">关联门店与角色</p>
        <div style="margin: 15px 0;">
          <el-input v-model="searchValue" placeholder="请输入门店关键字搜索" class="mR-20" />
          <el-button type="primary" icon="el-icon-search" @click="filterList" >搜索</el-button>
          <el-button type="primary" @click="resetList">重置</el-button>
        </div>

        <p>共{{total}}个门店，已选{{Object.keys(this.selection).length}}个门店</p>
        <el-table
          :data="storeList"
          border
          ref="storeList"
          @select="handleSelect"
          @select-all="handleSelectAll"
          @selection-change="handleSelectionChange"
          style="width:400px;"
        >
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column prop="storeName" label="门店名称" align="center"></el-table-column>
          <el-table-column align="center">
            <template slot="header">
              门店角色
              <el-popover placement="top-start" title="角色说明" width="500" trigger="hover">
                <p>门店管理员：可登录商城APP进行下单等操作，可添加/删除门店人员</p>
                <p>门店人员：可登录商城APP进行下单等操作，不可添加/删除门店人员</p>
                <el-button style="border:none;" slot="reference" icon="el-icon-question" circle></el-button>
              </el-popover>
            </template>
            <template slot-scope="scope">
              <el-select v-model="scope.row.roleId" @change="changeRoleId">
                <el-option label="门店管理员" :value="5"></el-option>
                <el-option label="门店人员" :value="1"></el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table>
        <div class="footer">
          <el-pagination
            style="float: left;"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="formData.page"
            :page-size.sync="formData.size"
            :page-sizes="[20, 30, 40, 50]"
            layout="total, sizes, prev, pager, next, jumper"
            :total.sync="total"
            background
          ></el-pagination>
        </div>
        <p class="title" style="margin-top: 40px;">账号信息</p>
        <el-form-item prop="phone" label="绑定手机号">{{formData.phone}}</el-form-item>
      </el-form>
      <div class="footer">
        <div v-if="$route.query.type==='1'">
          <el-button size="mini" @click="$router.go(-1)">返回</el-button>
        </div>
        <div v-else>
          <el-button size="mini" @click="$router.go(-1)">取消</el-button>
          <el-button type="primary" size="mini" @click="handleSubmit">保存</el-button>
        </div>
      </div>
    </basic-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formData: {
        phone: "",
        memberName: "",
        storeIds: [],
        storeList: [],
        page: 1,
        size: 20
      },
      total: 0,
      originName: "",
      originStoreIds: [],
      selection: {},
      storeList: [],
      isEnableList: [],
      searchValue: "",
      rules: {
        phone: [{ required: true, message: "请绑定手机号" }],
        memberName: [{ required: true, message: "请输入人员姓名" }],
        storeIds: [{ required: true, message: "请关联门店" }]
      }
    };
  },
  watch: {
    'formData.size': {
      immediate: true,
      handler(val) {
        if(!val) this.formData.size = 20;
      }
    }
  },
  async created() {
    await this.getRelList();
    await this.getPersonDetail();
    this.storeList = this.storeList.map(v => {
      let temp = this.formData.storeList.filter(
        i => i.storeId === v.storeId
      ) || [{}];
      return Object.assign(v, temp[0]);
    });
    this.formData.storeList.forEach(row => {
      this.selection[row.storeId] = row;
    });
    this.makeToggle()
  },
  methods: {
    async getRelList() {
      const { formData: { page, size }, searchValue: name } = this;
      const { ret, data: { list, total } } = await _api.store.getPageRelList({
        name,
        page,
        size
      });
      if (ret) {
        this.storeList = list.map(v => {
          return {
            storeId: v.storeId,
            storeName: v.storeName,
            roleId: 5,
            isEnable: v.isEnable
          };
        });
        this.total = total;
        this.washListBySelection();
        if(this.isEnableList.length) {
          this.storeList.forEach(store => {
            if(this.isEnableList.includes(store.storeId)) store.isEnable = 1;
          })
        }
        this.makeToggle();
      }
    },
    handleSelectionChange(val) {
      this.formData.storeList = val;
    },
    changeRoleId() {
      this.formData.storeList = this.$refs["storeList"].selection;
      this.formData.storeList.forEach(item => {
        if(this.selection[item.storeId.toString()]) this.selection[item.storeId.toString()] = item;
      })
    },
    async getPersonDetail() {
      const { ret, data } = await _api.member.getPersonDetail({
        id: this.$route.query.id
      });
      if (ret && data) {
        const { memberName, phone, storeIds, storeList } = data;
        Object.assign(this, {
          formData: { memberName, phone, storeIds, storeList },
          originName: memberName,
          originStoreIds: storeList instanceof Array ? storeList : []
        });
      }
    },
    handleSubmit() {
      this.$refs["addPersonnel"].validate(val => {
        if (val) {
          this.save();
        }
      });
    },
    async save() {
      let count = 0;
      if (this.originName !== this.formData.memberName) {
        const { ret: case1, data } = await _api.member.save({
          name: this.formData.memberName,
          memberId: this.$route.query.id
        });
        if (case1 && data) {
          count++;
        }
      }
      let opMapList = this.DataClassification();
      if (opMapList.addList.length > 30 ) {
        this.$message({
          type: "warning",
          message: "一次最多新增关联30个门店"
        })
        return ;
      }
      if (opMapList.deleteList.length || opMapList.addList.length || opMapList.updateList.length) {
        const { ret: case2, data } = await _api.member.saveRelStore({
          memberId: this.$route.query.id,
          storeIds: this.formData.storeIds,
          storeList: this.formData.storeList,
          opMapList
        });
        if (case2 && data) {
          count++;
        }
      }
      if (!count) {
        this.$message({
          type: "warning",
          message: "请修改信息后提交"
        });
        return;
      }
      if (count) {
        this.$message({
          type: "success",
          message: "保存成功"
        });
        this.$router.go(-1);
      }
    },
    filterList() {
      this.formData.page = 1;
      this.getRelList();
    },
    makeToggle() {
      var keys= Object.keys(this.selection)
      var rows= this.storeList.filter((row)=> {
        return keys.includes(String(row.storeId))
      })
      this.$nextTick(()=> {
        rows.map(row=> {
          this.$refs["storeList"].toggleRowSelection(row);
        })
      })
    },
    washListBySelection() {
      let keys = Object.keys(this.selection);
      this.storeList = this.storeList.map(val=> {
        if(keys.indexOf(val.storeId.toString()) > -1) return this.selection[keys[keys.indexOf(val.storeId.toString())]]
        return val;
      })
    },
    handleSelect(selection, row) {
      if(this.selection[row.storeId]){
        // delete this.selection[row.storeId]
        if(!row.isEnable) {
          var temp = this.storeList.filter(item => item.storeId === row.storeId)
          // 修改某个选项从不可选变成可选并且记录下来
          temp[0].isEnable = 1;
          this.isEnableList.push(row.storeId)
        }
        this.$delete(this.selection, row.storeId)
      }else{
        // this.selection[row.storeId] = row
        if(!row.isEnable) {
          this.$message({
            type: "warning",
            message: "当前门店已达关联上限"
          })
          this.$nextTick(() => {
            this.$refs["storeList"].toggleRowSelection(row);
          })
          return ;
        }
        this.$set(this.selection, row.storeId, row)
      }
    },
    handleSelectAll(selection, row) {
      if(selection.length) {
        var temp = selection.filter(row => row.isEnable)
        if(selection.length !== temp.length){
          this.$message({
            type: "warning",
            message: "部分门店已达关联上限"
          })
        }
        this.$nextTick(()=> {
          this.$refs["storeList"].clearSelection();
          temp.map(row=> {
            this.$refs["storeList"].toggleRowSelection(row);
          })
        })
        temp.forEach(row => {
          // this.selection[row.storeId] = row
          this.$set(this.selection, row.storeId, row)
        })
      }else {
        Object.keys(this.selection).forEach(key=> {
          // delete this.selection[key]
          this.$delete(this.selection, key)
        })
      }
    },
    resetList() {
      this.searchValue = "";
      this.storeListB = JSON.parse(JSON.stringify(this.storeList));
      this.makeToggle()
    },
    handleSizeChange() {
      this.formData.page = 1;
      this.getRelList();
    },
    handleCurrentChange() {
      this.getRelList()
    },
    selectable(row) {
      return row.isEnable? true : false;
    },
    DataClassification() {
      // 将数据划分成新增，删除，修改
      // orign 为原数据， now 为现在数据  orign - now = delete; now - orgin = add; 剩下的为修改的；
      const { originStoreIds: orign = [], selection: now} = this;
      let orignKey = orign.map(val => val.storeId.toString());
      let nowKey = Object.keys(now);
      const deleteKey = this.diff(orignKey, nowKey);
      let deleteList = orign.filter(item => deleteKey.includes(item.storeId.toString()));
      const addKey = this.diff(nowKey, orignKey);
      let addList = addKey.map(key => now[key])
      const updateKey = this.intersect(orignKey, nowKey);
      let updateList = [];
      orign.forEach(item=> {
        if(updateKey.includes(item.storeId.toString()) && item.roleId !== now[item.storeId.toString()].roleId)
          updateList.push(now[item.storeId.toString()])
        })
      return {
        deleteList,
        addList,
        updateList
      }
    },
    // 差集
    diff(a, b) {
      return ([...a].filter(x => !b.includes(x)));
    },
    // 交集
    intersect(a, b) {
      return ([...a].filter(x => b.includes(x)));
    }
  }
};
</script>
<style scoped>
.el-input {
  width: 300px;
}
.title {
  font-weight: 900;
  font-size: 16px;
}
</style>